module.exports = __webpack_public_path__ + "static/media/StrengthMagazineSpread3.6ee3be52.jpg";